// UI strings per language. Content data (projects, timeline, ...) lives in
// portfolio.js (EN) and portfolio.fr.js (FR); this file holds the interface
// copy around it.

export const strings = {
  en: {
    nav: {
      hero: 'Home', about: 'About', skills: 'Skills',
      projects: 'Work', experience: 'Experience', contact: 'Contact',
      cv: 'CV',
    },
    hero: {
      greet: "Hi, I'm Simon —",
      shipping: 'Currently shipping ',
      viewWork: 'View my work',
      downloadCv: 'Download CV',
      stack: 'Stack',
      scroll: 'Scroll',
    },
    stats: { workedWith: 'Worked with' },
    about: {
      eyebrow: 'About me',
      h2a: 'A full-stack developer who ',
      h2b: 'ships',
      sub: 'I care as much about clean architecture and delivery as the details users actually feel.',
      currently: 'Currently',
      currentlyRole: 'Full-Stack Developer',
      currentlyDesc: 'Building internal business apps (PHP, React, SQL) used daily by ~350 agents — full cycle, in Agile.',
      languages: 'Languages',
      highlights: [
        'Owns the full Agile cycle: analysis → build → test → production',
        'Comfortable across front-end, back-end & mobile',
        'Ships DevOps-ready: Docker, CI/CD, Git workflows',
        "Master's in Software Engineering (Université d'Avignon)",
      ],
    },
    skills: {
      eyebrow: 'Toolbox',
      h2a: 'Skills & ',
      h2b: 'technologies',
      sub: 'The stack I reach for to design, build, ship and operate software.',
    },
    projects: {
      eyebrow: 'Selected work',
      h2a: 'Case studies & ',
      h2b: 'projects',
      sub: 'Real products across enterprise, public-sector and personal work. Click any card for the full story.',
      hint: 'Drag to spin — click a card to open',
      readCase: 'Read case study',
      challenge: 'The challenge',
      what: 'What I did',
      result: 'The result',
      tech: 'Tech',
      viewLive: 'View live',
      viewCode: 'View code',
      privateFallback: 'Private project',
    },
    experience: {
      eyebrow: 'My journey',
      h2a: 'Experience & ',
      h2b: 'education',
      sub: 'From IT support in Lebanon to full-stack development in the south of France.',
    },
    contact: {
      eyebrow: 'Get in touch',
      h2a: "Let's build something ",
      h2b: 'together',
      sub: 'Open to Full-Stack roles (CDI) and interesting projects. I usually reply within a day.',
      detailsH: 'Contact details',
      detailsSub: 'Reach me directly through any of these — or grab my CV.',
      email: 'Email',
      phone: 'Phone',
      basedIn: 'Based in',
      basedVal: 'open to relocation/remote',
      downloadCv: 'Download my CV',
      formTitle: 'simon@contact:~$ send-message',
      formEmail: 'Email',
      formMsg: 'Message',
      emailPh: 'you@example.com',
      msgPh: 'Tell me about the role or project...',
      send: 'Send message',
      sending: 'Sending...',
      success: 'Thanks! Your message has been sent successfully.',
    },
    footer: {
      tagline: 'Full-Stack Developer crafting clean, scalable products. Thanks for stopping by.',
      built: 'Built with React &',
      backToTop: 'Back to top',
    },
    notFound: {
      sub: 'This page went off the grid',
      text: "The page you're after doesn't exist, moved, or was never built. No worries — even the best routers get lost sometimes.",
      home: 'Back to home',
      github: 'Check my GitHub',
      hintA: 'Psst — try the',
      hintB: 'code anywhere on the site.',
    },
  },

  fr: {
    nav: {
      hero: 'Accueil', about: 'À propos', skills: 'Compétences',
      projects: 'Projets', experience: 'Parcours', contact: 'Contact',
      cv: 'CV',
    },
    hero: {
      greet: "Salut, moi c'est Simon —",
      shipping: 'En ce moment : ',
      viewWork: 'Voir mes projets',
      downloadCv: 'Télécharger le CV',
      stack: 'Stack',
      scroll: 'Défiler',
    },
    stats: { workedWith: 'Ils m’ont fait confiance' },
    about: {
      eyebrow: 'À propos',
      h2a: 'Un développeur full-stack qui ',
      h2b: 'livre',
      sub: "L'architecture propre et la livraison comptent autant pour moi que les détails que les utilisateurs ressentent vraiment.",
      currently: 'Actuellement',
      currentlyRole: 'Développeur Full-Stack',
      currentlyDesc: "Développement d'applications métier internes (PHP, React, SQL) utilisées chaque jour par ~350 agents — cycle complet, en Agile.",
      languages: 'Langues',
      highlights: [
        'Maîtrise du cycle Agile complet : analyse → développement → tests → production',
        "À l'aise sur le front-end, le back-end & le mobile",
        'Livraisons DevOps-ready : Docker, CI/CD, workflows Git',
        "Master en génie logiciel (Université d'Avignon)",
      ],
    },
    skills: {
      eyebrow: 'Boîte à outils',
      h2a: 'Compétences & ',
      h2b: 'technologies',
      sub: "La stack que j'utilise pour concevoir, développer, livrer et exploiter des logiciels.",
    },
    projects: {
      eyebrow: 'Projets sélectionnés',
      h2a: 'Études de cas & ',
      h2b: 'projets',
      sub: "De vrais produits — entreprise, secteur public et projets personnels. Cliquez sur une carte pour l'histoire complète.",
      hint: 'Faites glisser pour tourner — cliquez sur une carte pour ouvrir',
      readCase: "Lire l'étude de cas",
      challenge: 'Le défi',
      what: "Ce que j'ai fait",
      result: 'Le résultat',
      tech: 'Technos',
      viewLive: 'Voir en ligne',
      viewCode: 'Voir le code',
      privateFallback: 'Projet privé',
    },
    experience: {
      eyebrow: 'Mon parcours',
      h2a: 'Expérience & ',
      h2b: 'formation',
      sub: 'Du support informatique au Liban au développement full-stack dans le sud de la France.',
    },
    contact: {
      eyebrow: 'Contact',
      h2a: 'Construisons quelque chose ',
      h2b: 'ensemble',
      sub: 'Ouvert aux postes Full-Stack (CDI) et aux projets intéressants. Je réponds généralement sous 24h.',
      detailsH: 'Coordonnées',
      detailsSub: 'Contactez-moi directement par l’un de ces canaux — ou téléchargez mon CV.',
      email: 'Email',
      phone: 'Téléphone',
      basedIn: 'Basé à',
      basedVal: 'mobilité / télétravail possibles',
      downloadCv: 'Télécharger mon CV',
      formTitle: 'simon@contact:~$ envoyer-message',
      formEmail: 'Email',
      formMsg: 'Message',
      emailPh: 'vous@exemple.com',
      msgPh: 'Parlez-moi du poste ou du projet...',
      send: 'Envoyer le message',
      sending: 'Envoi...',
      success: 'Merci ! Votre message a bien été envoyé.',
    },
    footer: {
      tagline: 'Développeur Full-Stack — des produits propres et scalables. Merci de votre visite.',
      built: 'Conçu avec React &',
      backToTop: 'Retour en haut',
    },
    notFound: {
      sub: 'Cette page a quitté le réseau',
      text: "La page que vous cherchez n'existe pas, a été déplacée, ou n'a jamais été construite. Pas de panique — même les meilleurs routeurs se perdent parfois.",
      home: "Retour à l'accueil",
      github: 'Voir mon GitHub',
      hintA: 'Psst — essayez le code',
      hintB: "n'importe où sur le site.",
    },
  },
};

export default strings;
